import {
  UNLOAD_VENUE_FINANCIALS,
  VENUE_FINANCIALS_ERROR,
  VENUE_FINANCIALS_RECEIVED,
  VENUE_FINANCIALS_REQUEST,
} from "../reducers/types";
import * as VENUE_ROUTES from "../../Router/venue_routes";
import axios from "axios";
import handleErrors from "./utils";

export const venueFinancialsRequest = () => ({
  type: VENUE_FINANCIALS_REQUEST,
});

export const venueFinancialsRequestReceived = data => ({
  type: VENUE_FINANCIALS_RECEIVED,
  ...data,
});

export const venueFinancialsError = error => ({
  type: VENUE_FINANCIALS_ERROR,
  error,
});

export const unloadVenueFinancials = () => ({
  type: UNLOAD_VENUE_FINANCIALS,
});

export const fetchVenueFinancials = (token, venueSlug) => {
  return dispatch => {
    dispatch(venueFinancialsRequest());
    return axios
      .get(
        window.API +
          VENUE_ROUTES.API.VENUE.FINANCIALS.replace(":venue", venueSlug),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(response => {
        dispatch(venueFinancialsRequestReceived(response.data));
      })
      .catch(error => {
        dispatch(venueFinancialsError(error));
        handleErrors(error);
      });
  };
};

export const editVenueFinancials = (token, venueSlug, formValues) => {
  return dispatch => {
    dispatch(venueFinancialsRequest());
    return axios
      .post(
        window.API +
          VENUE_ROUTES.API.VENUE.FINANCIALS.replace(":venue", venueSlug),
        formValues,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(response => {
        dispatch(venueFinancialsRequestReceived(response.data));
      })
      .catch(error => {
        dispatch(venueFinancialsError(error));
      });
  };
};

export const editVenueFinancialsForEvent = (token, venueSlug, eventId, formValues) => {
  return dispatch => {
    dispatch(venueFinancialsRequest());
    return axios
      .post(
        window.API +
        VENUE_ROUTES.API.VENUE.FINANCIALS_FOR_EVENT.replace(":venue", venueSlug).replace(':event', eventId),
        formValues,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(response => {
        dispatch(venueFinancialsRequestReceived(response.data));
      })
      .catch(error => {
        dispatch(venueFinancialsError(error));
      });
  };
};